import { useQuery } from "@tanstack/react-query";
import { RolesAndPrivilegesControllerApi } from "../../services";
import {
  useBaseContent,
  getConfigObject,
  getXtenantId,
} from "../../utils/utils";

interface Params {
  getAllPrivilegesModule?: string;
  roleId: number;
}

/**
 * to get the privileges list as per module name.
 * @author rajkumar rathod
 */
export function useGetAllPrivileges(param?: Params): useBaseContent<any> {
  return useQuery({
    queryKey: ["get_all_privileges", param],
    refetchOnWindowFocus: false,
    enabled: !!param?.getAllPrivilegesModule && !!param.roleId,
    queryFn: async () =>
      new RolesAndPrivilegesControllerApi(getConfigObject())
        .getAllPrivileges(
          param?.getAllPrivilegesModule,
          param?.roleId,
          getXtenantId()
        )
        .then((res) => res?.data),
  });
}
